/**
 * Spinner.js
 */

import $ from 'jquery';

class Spinners {

    constructor() {

        this.$el = {
            spinners: null,
        }

        this.init();

    }

    init() {

        this.$el.spinners = document.querySelector('.button-spinner svg');
        this.events();

    }

    events() {

        var self = this;
        window.addEventListener("scroll", function () {
            $(self.$el.spinners).each(function () {
                this.style.transform = "rotate(" + window.pageYOffset + "deg)";
            })
        });

    }

}
new Spinners();